export default Object.freeze({
	READY: 'ready',
	LOADED: 'loaded',
	RESIZED: 'resized',
	CONTENT_CHANGED: 'contentChange',
	SCROLLED: 'scrolled',
	LOGIN: 'login',
	ERROR: 'error'
});
